import React from "react";
import styled from "styled-components";

import { Input } from "@ui/Atoms";
import { FlowPanel } from "@ui/Molecules";
import { rem } from "@ui/helpers";

interface Props {
  relocationCountry: string;
  relocationCity: string;
  onCountryChange: (value: string) => void;
  onCityChange: (value: string) => void;
  translations: {
    headingText: string;
    descriptionText: string;
    countryText: string;
    cityText: string;
    optionalText: string;
  };
}

const Relocation = (props: Props): React.ReactElement => (
  <div>
    <FlowPanel.Title type="h5" size="small">
      {props.translations.headingText}
    </FlowPanel.Title>
    <FlowPanel.Description>
      {props.translations.descriptionText}
    </FlowPanel.Description>

    <InputWrapper>
      <CountryInputWrapper>
        <Input
          name="relocationCountry"
          value={props.relocationCountry}
          label={props.translations.countryText}
          optionalLabel={props.translations.optionalText}
          onChange={e => props.onCountryChange(e.target.value)}
        />
      </CountryInputWrapper>

      <Input
        name="relocationCity"
        value={props.relocationCity}
        label={props.translations.cityText}
        optionalLabel={props.translations.optionalText}
        onChange={e => props.onCityChange(e.target.value)}
      />
    </InputWrapper>
  </div>
);

export { Relocation };

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  ${props => props.theme.breakpoints.tablet} {
    max-width: ${rem(328)};
    margin: 0 auto;
  }

  > div {
    width: 100%;
  }
`;

const CountryInputWrapper = styled(InputWrapper)`
  margin-bottom: ${props => props.theme.margins.base_x3};
`;
